export const PAGE_TITLE = '门店详情'
export const PAGE_TITLE_SHOP = '店铺详情'
export const PAGE_TITLE_SCENIC = '景区详情'
export const PAGE_TITLE_ALBUM = '商家相册'

export const KIDSWANT_BUSSINESSID = '41215'

export const URL_GET_COMMENT = 'https://soperationapi.czj100.com/soperation-api/comment/list2.do'

export const URL_GET_COMMENT2 = 'https://czjcapi.czj100.com/api-c/comment/getEssenceComments.do'

export const URL_GET_SHOP_DETAIL = 'https://scbapi.czj100.com/scb-api/appStore/queryStoreById.do'

export const URL_GET_SERVICE_ITEM = 'https://svsesapi.haiziwang.com/svses-api/api/queryCommodity.do'

export const URL_GET_USERINFO = 'https://user.cekid.com/user/GetUserInfo'

export const URL_GET_COUPON = 'https://scouponapi.czj100.com/scoupon-api/coupon/getMerchantCoupons.do'  // 获取商户优惠券列表

export const URL_SEND_COUPON = "https://scouponapi.czj100.com/scoupon-api/userCoupon/sendCoupon.do"  // 领取优惠券

export const URL_GET_DAODIAN_CATEGORY = "https://scbapi.czj100.com/scb-api/appStore/queryDaoDianCategory.do"  // 查询到店品类

export const SHARE_MSG = '在孩子王app上发现这个店很不错哦'

export enum ShopTypes {
    Common = "通用",
    Pregnancy = "孕产加",
    Children = "小儿纪念品",
    Photography = "摄影",
    Education = "早教、英语、素质教育",
    Ticket = "门票"
}
